// export default Breadcrumb;

import React from "react";
import PropTypes from "prop-types";
import { Link, useLocation, useRouteMatch } from "react-router-dom";
import { Row, Col, Breadcrumb as ReactstrapBreadcrumb, BreadcrumbItem } from "reactstrap";

import { APP_ROUTES, getParamsAttachedRoute } from "../../helpers/routeHelpers";
import "./Breadcrumb.scss";

const Breadcrumb = ({ title, breadcrumbItems }) => {
    const matches = useRouteMatch();

    const { pathname } = useLocation();
    const pathNameArr = pathname?.split("/");

    const routeConfigs = [
        {
            path: APP_ROUTES.DASHBOARD,
            title: "Dashboard",
            count: "1",
            matchUrl: "/dashboard",
            key: "01"
        },
        {
            path: APP_ROUTES.USER_MANAGEMENT,
            title: "User Management",
            count: "1",
            matchUrl: "/users",
            key: "02"
        },

        {
            // path: APP_ROUTES.USER_MANAGEMENT_DETAILS,
            path: getParamsAttachedRoute(APP_ROUTES.USER_MANAGEMENT_DETAILS, {
                userId: matches?.params?.userId
            }),
            title: "User Details",
            count: "2",
            matchUrl: "/users/:userId",
            key: "03"
        },

        // Singles
        {
            path: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SINGLES,
            title: "Audio Content Management - Singles",
            count: "1",
            matchUrl: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SINGLES,
            key: "04"
        },
        {
            path: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SINGLES_ADD,
            title: "Add Single Audio",
            count: "2",
            matchUrl: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SINGLES_ADD,
            key: "05"
        },
        {
            path: getParamsAttachedRoute(APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SINGLES_DETAILS, {
                singlesID: matches?.params?.singlesID
            }),
            title: "View Single Audio",
            count: "2",
            matchUrl: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SINGLES_DETAILS,
            key: "06"
        },
        {
            path: getParamsAttachedRoute(APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SINGLES_UPDATE, {
                singlesID: matches?.params?.singlesID
            }),
            title: "Edit Single Audio",
            count: "2",
            matchUrl: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SINGLES_UPDATE,
            key: "07"
        },

        // Series
        {
            path: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SERIES,
            title: "Audio Content Management - Series",
            count: "1",
            matchUrl: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SERIES,
            key: "08"
        },
        {
            path: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SERIES_ADD,
            title: "Add Series Audio",
            count: "2",
            matchUrl: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SERIES_ADD,
            key: "09"
        },
        {
            path: getParamsAttachedRoute(APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SERIES_DETAILS, {
                seriesID: matches?.params?.seriesID
            }),
            title: "View Series Audio",
            count: "2",
            matchUrl: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SERIES_DETAILS,
            key: "10"
        },
        {
            path: getParamsAttachedRoute(APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SERIES_UPDATE, {
                seriesID: matches?.params?.seriesID
            }),
            title: "Edit Series Audio",
            count: "2",
            matchUrl: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SERIES_UPDATE,
            key: "11"
        },

        // Soundscapes
        {
            path: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SOUNDSCAPES,
            title: "Audio Content Management - Soundscapes",
            count: "1",
            matchUrl: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SOUNDSCAPES,
            key: "12"
        },
        {
            path: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SOUNDSCAPES_ADD,
            title: "Add Soundscape Audio",
            count: "2",
            matchUrl: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SOUNDSCAPES_ADD,
            key: "13"
        },
        {
            path: getParamsAttachedRoute(APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SOUNDSCAPES_DETAILS, {
                soundscapesID: matches?.params?.soundscapesID
            }),
            title: "View Soundscape Audio",
            count: "2",
            matchUrl: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SOUNDSCAPES_DETAILS,
            key: "14"
        },
        {
            path: getParamsAttachedRoute(APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SOUNDSCAPES_UPDATE, {
                soundscapesID: matches?.params?.soundscapesID
            }),
            title: "Edit Soundscape Audio",
            count: "2",
            matchUrl: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SOUNDSCAPES_UPDATE,
            key: "15"
        },

        // Shares
        {
            path: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SHARES,
            title: "Audio Content Management - Stories",
            count: "1",
            matchUrl: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SHARES,
            key: "16"
        },
        {
            path: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SHARES_ADD,
            title: "Add Story Audio",
            count: "2",
            matchUrl: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SHARES_ADD,
            key: "17"
        },
        {
            path: getParamsAttachedRoute(APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SHARES_DETAILS, {
                sharesID: matches?.params?.sharesID
            }),
            title: "View Story Audio",
            count: "2",
            matchUrl: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SHARES_DETAILS,
            key: "18"
        },
        {
            path: getParamsAttachedRoute(APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SHARES_UPDATE, {
                sharesID: matches?.params?.sharesID
            }),
            title: "Edit Story Audio",
            count: "2",
            matchUrl: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SHARES_UPDATE,
            key: "19"
        },
        // onboarding
        {
            path: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_ONBOARDING,
            title: "Audio Content Management - Onboarding",
            count: "1",
            matchUrl: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_ONBOARDING,
            key: "20"
        },
        {
            path: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_ONBOARDING_ADD,
            title: "Add Onboarding Audio",
            count: "2",
            matchUrl: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_ONBOARDING_ADD,
            key: "21"
        },
        {
            path: getParamsAttachedRoute(APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_ONBOARDING_DETAILS, {
                onboardingID: matches?.params?.onboardingID
            }),
            title: "View Onboarding Audio",
            count: "2",
            matchUrl: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_ONBOARDING_DETAILS,
            key: "22"
        },
        {
            path: getParamsAttachedRoute(APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_ONBOARDING_UPDATE, {
                onboardingID: matches?.params?.onboardingID
            }),
            title: "Edit Onboarding Audio",
            count: "2",
            matchUrl: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_ONBOARDING_UPDATE,
            key: "23"
        },
        // Goal Trackers
        {
            path: APP_ROUTES.GOAL_MANAGEMENT_PRIMARY,
            title: "Goal Management - Primary",
            count: "1",
            matchUrl: APP_ROUTES.GOAL_MANAGEMENT_PRIMARY,
            key: "20"
        },
        {
            path: APP_ROUTES.GOAL_MANAGEMENT_SECONDARY,
            title: "Goal Management - Secondary",
            count: "2",
            matchUrl: APP_ROUTES.GOAL_MANAGEMENT_SECONDARY,
            key: "21"
        },
        {
            path: getParamsAttachedRoute(APP_ROUTES.GOAL_MANAGEMENT_PRIMARY_EDIT, {
                id: matches?.params?.id
            }),
            title: "Edit Goal",
            count: "2",
            matchUrl: APP_ROUTES.GOAL_MANAGEMENT_PRIMARY_EDIT,
            key: "22"
        },
        {
            path: getParamsAttachedRoute(APP_ROUTES.GOAL_MANAGEMENT_SECONDARY_EDIT, {
                id: matches?.params?.id
            }),
            title: "Edit Goal",
            count: "2",
            matchUrl: APP_ROUTES.GOAL_MANAGEMENT_SECONDARY_EDIT,
            key: "23"
        },

        {
            path: APP_ROUTES.GOAL_MANAGEMENT_ADD,
            title: "Add Goal",
            count: "2",
            matchUrl: APP_ROUTES.GOAL_MANAGEMENT_ADD,
            key: "24"
        },
        {
            path: getParamsAttachedRoute(APP_ROUTES.GOAL_PRIMARY_DETAIL, {
                id: matches?.params?.id
            }),
            title: "Goal",
            count: "2",
            matchUrl: APP_ROUTES.GOAL_PRIMARY_DETAIL,
            key: "25"
        },
        {
            path: getParamsAttachedRoute(APP_ROUTES.GOAL_SECONDARY_DETAIL, {
                id: matches?.params?.id
            }),
            title: "Goal",
            count: "2",
            matchUrl: APP_ROUTES.GOAL_SECONDARY_DETAIL,
            key: "26"
        },
        {
            path: APP_ROUTES.NOTIFICATION_MANAGEMENT,
            title: "Notification Management",
            count: "1",
            matchUrl: "/notification",
            key: "27"
        },
        {
            path: APP_ROUTES.NOTIFICATION_MANAGEMENT_ADD,
            title: "Create",
            count: "2",
            matchUrl: "/notification/create",
            key: "28"
        },

        {
            // path: APP_ROUTES.USER_MANAGEMENT_DETAILS,
            path: getParamsAttachedRoute(APP_ROUTES.NOTIFICATION_MANAGEMENT_DETAILS, {
                notificationID: matches?.params?.notificationID
            }),
            title: "Details",
            count: "2",
            matchUrl: "/notification/detail/:notificationID",
            key: "29"
        },
        {
            // path: APP_ROUTES.USER_MANAGEMENT_DETAILS,
            path: getParamsAttachedRoute(APP_ROUTES.NOTIFICATION_MANAGEMENT_UPDATE, {
                notificationID: matches?.params?.notificationID
            }),
            title: "Update",
            count: "2",
            matchUrl: "/notification/update:notificationID",
            key: "30"
        },
        {
            path: APP_ROUTES.ACCOUNT_PROFILE,
            title: "Profile",
            count: "1",
            matchUrl: "/account/profile",
            key: "31"
        },
        {
            path: APP_ROUTES.ACCOUNT_CHANGE_PASSWORD,
            title: " Change Password",
            count: "2",
            matchUrl: "/account/change-password",
            key: "32"
        },
        {
            path: APP_ROUTES.NARRATOR_MANAGEMENT,
            title: "Narrator Management",
            count: "1",
            matchUrl: APP_ROUTES.NARRATOR_MANAGEMENT,
            key: "33"
        },
        {
            path: APP_ROUTES.AUTHOR_MANAGEMENT,
            title: "Author Management",
            count: "1",
            matchUrl: APP_ROUTES.AUTHOR_MANAGEMENT,
            key: "34"
        },

        {
            path: APP_ROUTES.NARRATOR_ADD,
            title: "Add Narrator",
            count: "2",
            matchUrl: APP_ROUTES.NARRATOR_ADD,

            key: "35"
        },
        {
            path: APP_ROUTES.AUTHOR_ADD,
            title: "Add Author",
            count: "2",
            matchUrl: APP_ROUTES.AUTHOR_ADD,
            key: "36"
        },
        {
            path: getParamsAttachedRoute(APP_ROUTES.NARRATOR_EDIT, {
                id: matches?.params?.id
            }),
            title: "Update Narrator",
            count: "2",
            matchUrl: "/author-and-narrator/narrators/edit/:id",
            key: "37"
        },
        {
            path: getParamsAttachedRoute(APP_ROUTES.AUTHOR_EDIT, {
                id: matches?.params?.id
            }),
            title: "Update Author",
            count: "2",
            matchUrl: "/author-and-narrator/authors/edit/:id",
            key: "38"
        },
        {
            path: getParamsAttachedRoute(APP_ROUTES.AUTHOR_DETAILS, {
                id: matches?.params?.id
            }),
            title: "Author",
            count: "2",
            matchUrl: "/author-&-narrator/authors/details/:id",
            key: "39"
        },
        {
            path: getParamsAttachedRoute(APP_ROUTES.NARRATOR_DETAILS, {
                id: matches?.params?.id
            }),
            title: "Narrator",
            count: "2",
            matchUrl: "/author-&-narrator/narrators/details/:id",
            key: "40"
        }

        // {
        //     path: getParamsAttachedRoute(APP_ROUTES.GOAL_MANAGEMENT_SECONDARY_EDIT, {
        //         id: matches?.params?.id
        //     }),
        //     title: "Edit Goal",
        //     count: "",
        //     matchUrl: APP_ROUTES.GOAL_MANAGEMENT_EDIT,
        //     key: "27"
        // }
    ];
    const breadcrumbItemsToRender = routeConfigs.filter((el) => pathname.includes(el.path));

    return (
        <Row className="breadcrumbs-con">
            <Col xs="12" className="breadcrumbs-col">
                <div className="d-flex align-items-center justify-content-between">
                    <ReactstrapBreadcrumb>
                        {breadcrumbItemsToRender.map((el, idx) => {
                            const isActive =
                                pathname === el.path || pathNameArr.includes(el.matchUrl);

                            return (
                                <BreadcrumbItem
                                    key={el.key}
                                    active={isActive}
                                    className={
                                        isActive
                                            ? "breadcrumb-typo-bold breadcrumb-max-width"
                                            : "breadcrumb-max-width breadcrumb-typo-bold "
                                    }
                                >
                                    {isActive || el.count === "2" ? (
                                        <span className="breadcrumb-typo-bold">{el.title} </span>
                                    ) : (
                                        <Link
                                            to={el.path}
                                            className="breadcrumb-typo breadcrumb-max-width"
                                        >
                                            {el.title}
                                        </Link>
                                    )}
                                </BreadcrumbItem>
                            );
                        })}
                    </ReactstrapBreadcrumb>
                </div>
            </Col>
        </Row>
    );
};

Breadcrumb.propTypes = {
    breadcrumbItems: PropTypes.array,
    title: PropTypes.string
};

export default Breadcrumb;
